import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import { Toast } from "buefy";
import VueScrollTo from "vue-scrollto";
import { VueMaskDirective } from "v-mask";
import "@/assets/styles/settings.scss";
import "vue-material-design-icons/styles.css";
import * as Sentry from "@sentry/vue";
import setupIframeNavigationHandler, {
  setupVueRouterIntegration,
} from "@/utils/iframe-navigation-handler";

Sentry.init({
  Vue,
  dsn:
    "https://34f438d3ed884308aa5eb4bb3bd71fef@glitch-xi26lpr5.flightsite.co.za/4",
  enabled: process.env.NODE_ENV === "production",
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracesSampleRate: 0.5,
  tracePropagationTargets: [
    "http://localhost:*",
    "https://flights.investectravel.com",
  ],
});

Vue.directive("mask", VueMaskDirective);
Vue.use(Buefy);
Vue.use(VueScrollTo);
Vue.use(Toast);

Vue.config.productionTip = false;

// Setup iframe navigation handlers for both link clicks and Vue Router
setupIframeNavigationHandler(); // Handles <a> link clicks
setupVueRouterIntegration(router); // Handles programmatic Vue Router navigation

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
